import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Launchpad, LaunchpadConfig } from './model/lunchpad';
import { map } from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { environment } from '../../environment/environment';
import { FavoriteAppDto } from './model/favorite-app-dto';

@Injectable({
  providedIn: 'root',
})
export class AcpLaunchpadService {
  private httpContext = inject(HttpClient);
  private authService = inject(AuthService);
  private serviceEndpoint = environment.APIBase + 'UserActivity/preferapp'; // Base URL for the service
  private mapLaunchpad(apiResponse: any): Launchpad[] {
    return apiResponse.map((item: any) => ({
      appPrefix: item.appPrefix,
      title: item.kacheltitel,
      description: item.infoTextLang,
      shortDescription: item.infoText,
      link: item.hrefLink,
      image: item.applogo ? item.applogo:'',
      sortOrder: item.sortOrder,
    })).sort((a: Launchpad, b: Launchpad) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
  }

  public getLaunchpadApps(): Promise<Launchpad[]> {
    return new Promise<Launchpad[]>((resolve, reject) => {
      this.authService.getAccessToken().then((res) => {
        const accessToken = res;
        const headers: Record<string, string> = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        };

        this.httpContext
          .get(environment.esspApiUrl, { headers })
          .pipe(map((res) => this.mapLaunchpad(res))) // Map response to Launchpad array
          .subscribe(
            (res: Launchpad[]) => {
              resolve(res); // Resolve with the fetched launchpad data
            },
            (error) => {
              console.error('Error in getLaunchpadApp', error); // Log error
              reject(error); // Reject promise with error
            },
          );
      });
    });
  }
  public getRestrictedLaunchpadApps(): Promise<Launchpad[]> {
    return new Promise<Launchpad[]>((resolve, reject) => {
      this.authService.getAccessToken().then((res) => {
        const accessToken = res;
        const headers: Record<string, string> = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        };

        this.httpContext
          .get(environment.esspRequiredAccessApiUrl, { headers })
          .pipe(map((res) => this.mapLaunchpad(res))) // Map response to Launchpad array
          .subscribe(
            (res: Launchpad[]) => {
              resolve(res); // Resolve with the fetched launchpad data
            },
            (error) => {
              console.error('Error in getRestrictedLaunchpadApp', error); // Log error
              reject(error); // Reject promise with error
            },
          );
      });
    });
  }
   public getLaunchpadVpnConfig(): Promise<LaunchpadConfig[]> {
    return new Promise<LaunchpadConfig[]>((resolve, reject) => {
        this.httpContext
          .get('assets/acp-launchpad-vpn-config.json')
          .pipe(map((res) => res as LaunchpadConfig[])) // Map response to Launchpad array
          .subscribe(
            (res: LaunchpadConfig[]) => {
              resolve(res); // Resolve with the fetched launchpad data
            },
            (error) => {
              console.error('Error in getRestrictedLaunchpadApp', error); // Log error
              reject(error); // Reject promise with error
            },
          );
      });
  }
  public getFavoriteApps(userId: string|undefined): Promise<FavoriteAppDto[]> {
    return new Promise<FavoriteAppDto[]>((resolve, reject) => {
        this.httpContext
           .get(this.serviceEndpoint + '?id='+userId)
          .pipe(map((res) => res as FavoriteAppDto[])) // Map response to Launchpad array
          .subscribe(
            (res: FavoriteAppDto[]) => {
              resolve(res); // Resolve with the fetched launchpad data
            },
            (error) => {
              console.error('Error in getFavoriteApps', error); // Log error
              reject(error); // Reject promise with error
            },
          );
      });
  }

  public manageFavoriteApp(favoriteApp: LaunchpadConfig): Promise<LaunchpadConfig> {
    return new Promise<LaunchpadConfig>((resolve, reject) => {
        this.httpContext
          .post(this.serviceEndpoint, favoriteApp)
          .pipe(map((res) => res as LaunchpadConfig)) // Map response to Launchpad array
          .subscribe(
            (res: LaunchpadConfig) => {
              resolve(res); // Resolve with the fetched launchpad data
            },
            (error) => {
              console.error('Error in manageFavoriteApp', error); // Log error
              reject(error); // Reject promise with error
            },
          );
      });
  }
}
